import vestel_logo from "../../../assets/images/vestel_logo.png"

const VestelLogo = ({ className }) => {
  return <img src={vestel_logo} alt="Vestel Logo" className={className} />;
};

export default VestelLogo;